/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ players: NonNullable<unknown> }} Rounds_Restore_BlockedInputs */



/**
* | output |
* | --- |
* | "Can't restore this round: {players} can't come back (dropped, disqualified, or out of rounds). Fix that first, or leave it cancelled." |
*
* @param {Rounds_Restore_BlockedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_restore_blocked = /** @type {((inputs: Rounds_Restore_BlockedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Restore_BlockedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Impossible de restaurer cette ronde : ${i?.players} ne peut plus revenir (abandon, disqualification ou toutes ses rondes jouées). Réglez cela d'abord, ou laissez la ronde annulée.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se puede restaurar esta ronda: ${i?.players} ya no puede volver (retirado, descalificado o sin rondas pendientes). Resuélvalo primero, o deje la ronda anulada.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Não é possível restaurar esta rodada: ${i?.players} não pode mais voltar (desistiu, foi desclassificado ou já jogou todas as rodadas). Resolva isso primeiro, ou deixe a rodada cancelada.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile ripristinare questo round: ${i?.players} non può più rientrare (ritirato, squalificato o senza round rimasti). Risolvi prima questo, o lascia il round annullato.`)
	return /** @type {LocalizedString} */ (`Can't restore this round: ${i?.players} can't come back (dropped, disqualified, or out of rounds). Fix that first, or leave it cancelled.`)
});